import Button from '@components/v2/ui/Button/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { useState } from 'react';
import Tooltip from '../../Tooltip';
import { useButtonBaseWithSelectionMenuStyles } from '../styles/useButtonBaseWithSelectionMenu.styles';

interface DisabledButtonTooltipProps {
  buttonContent: React.ReactNode;
  disabledTooltipLabel: string;
  testId?: string;
}

const ButtonWithTooltip = ({
  buttonContent,
  disabledTooltipLabel,
  testId,
}: DisabledButtonTooltipProps) => {
  const [openTooltip, setOpenTooltip] = useState(false);
  const { classes, cx } = useButtonBaseWithSelectionMenuStyles();
  return (
    <ClickAwayListener onClickAway={() => setOpenTooltip(false)}>
      <div>
        <Tooltip
          placement="left"
          PopperProps={{
            disablePortal: true,
          }}
          open={openTooltip}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={disabledTooltipLabel?.toLowerCase() || ''}
        >
          <Button
            variant="contained"
            color="secondary"
            size="small"
            fullWidth
            className={cx(classes.button, classes.disabledLookButton)}
            tabIndex={-1}
            testId={testId}
            onClick={() => setOpenTooltip((open) => !open)}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                justifyContent: 'space-between',
              }}
            >
              {buttonContent}
            </div>
          </Button>
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
};

export default ButtonWithTooltip;
